import {Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import {AppMainComponent} from '../../app.main.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AvatarModule } from 'primeng/avatar';
import { InMemoryCacheService, User, UtilsService } from 'src/app/common';

@Component({
    standalone: true,
    selector: 'app-inlinemenu',
    templateUrl: './app.inlinemenu.component.html',
    imports: [
        CommonModule,
        RouterLink,
        AvatarModule
    ],
    styles: [`:host ::ng-deep .layout-inline-menu .layout-inline-menu-action .p-avatar-text { color: #ffffff; }`],
    animations: [
        trigger('inline', [
            state('hidden', style({
                height: '0px',
                overflow: 'hidden'
            })),
            state('visible', style({
                height: '*',
            })),
            state('hiddenAnimated', style({
                height: '0px',
                overflow: 'hidden'
            })),
            state('visibleAnimated', style({
                height: '*',
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppInlineMenuComponent implements OnInit {

    public user: User;

    constructor(public appMain: AppMainComponent, private cache: InMemoryCacheService, private router: Router, private utils: UtilsService) {}

    ngOnInit() {

        this.user = this.cache?.auth?.user?.user;
        if (!this.user && !this.appMain.isAccountFlow()) {
            this.cache.logout();
        }
    }

    public onOrganizationClicked() {

    }

    public onLogoutClicked() {
        this.cache.logout();
    }

    get avatarLabel() {
        return this.user?.firstName?.charAt(0).toUpperCase();
    }
}
